module.exports = __webpack_public_path__ + "img/btn.b66d9b45.png";